export class chatService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }

    getChatHistory(admin) {
        const action = "getChatHistory";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "ChatHistory",
                data: admin
            }
            this.SingletonWebSocket.send(message);
        }
    }

    getSupervisorsToChat() {
        const action = "getSupervisorsToChat";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "AdminToChat"
            }
            this.SingletonWebSocket.send(message);
        }
    }

    sendClientChatMessage(admin, message) {
        const action = "sendClientChatMessage";
        if (!admin) {
            if (onError && typeof onError === 'function') {
                const error = { code: 7, message: "Invalid function at need admin" }
                onError(error);
            }
        }
        else if (message && this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const action = {
                client: "integration",
                action: "ChatToAdmin",
                data: { admin, message }
            }
            this.SingletonWebSocket.send(action);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/chatService.js